<template>
  <v-row justify="center" v-if="openModal">
    <v-dialog v-model="openModal" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card style="padding-bottom:60px !important">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Fechamento</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-container fluid>
          <div v-if="startLoading" class="loader-wrapper">
            <v-progress-circular indeterminate color="primary" size="64" />
          </div>
          <v-form v-else ref="closingForm" v-model="validForm" lazy-validation>
            <!-- Propostas Aprovadas -->
            <v-card class="mb-6" outlined>
              <v-card-title class="text-h6 primary--text">
                <v-icon left color="primary">mdi-file-document-check</v-icon>
                Propostas Aprovadas
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-select item-value="id_doc" label="Propostas" item-text="name" :items="proposalList"
                      v-model="proposalsToGetContract" multiple outlined
                      :rules="[v => !!v && v.length > 0 || 'Selecione pelo menos uma proposta']" />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea label="Observações Contratuais" 
                      v-model="contract.observations" row-height="25" rows="5"
                      outlined no-resize />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Dados do Cliente -->
            <v-card class="mb-6" outlined>
              <v-card-title class="text-h6 primary--text">
                <v-icon left color="primary">mdi-account</v-icon>
                Dados do Cliente
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="closingData.name" label="Razão Social / Nome" :rules="rulesRequired" outlined
                      dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="closingData.document" label="CNPJ / CPF" :rules="rulesRequired" outlined
                      dense></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="closingData.address" label="Endereço" :rules="rulesRequired" outlined
                      dense></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <InputFiles title="Cartão CNPJ" :fileTypes="['pdf', 'image']"
                      :showFile="closingData.file_file_cnpj_card" :rules="rulesRequired"
                      @change:file="(file) => closingData.cnpjCard = file" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Dados de Cobrança -->
            <v-card class="mb-6" outlined>
              <v-card-title class="text-h6 primary--text">
                <v-icon left color="primary">mdi-currency-usd</v-icon>
                Dados de Cobrança
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-checkbox v-model="useClientData" label="Usar dados do cliente"
                      @change="handleUseClientDataChange"></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="closingData.billingEmail" label="Email"
                      :rules="[v => !!v || 'Email é obrigatório', ...ruleEmail]" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="closingData.billingPhone" label="Telefone"
                      :rules="[v => !!v || 'Telefone é obrigatório']" v-mask="'(##) # ####-####'" outlined
                      dense></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Dados do Responsável -->
            <v-card class="mb-6" outlined>
              <v-card-title class="text-h6 primary--text">
                <v-icon left color="primary">mdi-account-tie</v-icon>
                Dados do Responsável
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="closingData.responsibleName" label="Nome" :rules="rulesRequired" outlined
                      dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <selectResponsibleType :id_responsible_type="closingData.id_responsible_type" :rules="rulesRequired"
                      @id="(id) => closingData.id_responsible_type = id" dense outlined />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="closingData.responsibleEmail" label="Email" :rules="ruleEmail" outlined
                      dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="closingData.responsibleCPF" label="CPF" :rules="ruleCPF"
                      v-mask="'###.###.###-##'" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="closingData.responsibleRG" label="RG" :rules="rulesRequired" outlined
                      dense></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <InputFiles title="Identidade do Responsável" :fileTypes="['pdf', 'image']"
                      :showFile="closingData.file_responsible_id" :rules="rulesRequired"
                      @change:file="(file) => closingData.responsibleId = file" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <!-- Dados Adicionais -->
            <v-card class="mb-6" outlined>
              <v-card-title class="text-h6 primary--text">
                <v-icon left color="primary">mdi-plus-circle</v-icon>
                Dados Adicionais
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <input-multiple-files
                      v-model="additionalFiles"
                      acceptedFileTypes=".pdf"
                      :maxFileSize="10 * 1024 * 1024"
                      @error="(error) => showErrorSnackBar(error)"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
        </v-container>
        <!-- //:disabled="project.id_contract !== null" -->
        <NextStepProject :message="buttonMessage" :click="nextStep" :loading="is_loading || startLoading"/>
      </v-card>
    </v-dialog>
    <AverageNextStep
                ref="averageModal"
                :model-value="showAverageNextStep"
                :next-step="nextStepVariable"  
              />
  </v-row>
</template>

<script>
import Rules from "@/utils/Rules";
import Utils from '@/scripts/Utils';
import NextStepProject from "@/components/Projects/NextStepProject.vue"
import DiagnosticProposalService from '@/services/firebase/DiagnosticProposal/DiagnosticProposalService';
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper"
import ProjectsService from "@/services/server/ProjectsService.js";
import UtilsProjects from "@/pages/Projects/Utils/Utils.js";
import InputFiles from "@/components/Forms/Input/input-files.vue";
import InputMultipleFiles from "@/components/Forms/Input/input-multiple-files.vue";
import ContractStorage from '@/services/storage/ContractStorage';
import LeadsService from "@/services/server/LeadsService.js";
import selectResponsibleType from "../Components/select-responsible-type.vue";
import LeadsStorage from "@/services/storage/LeadsStorage";
import ContractsService from "@/services/firebase/Contracts/ContractsService";
import cloneDeep from 'lodash/cloneDeep';
import AverageNextStep from "../../AverageNextStep/AverageNextStep.vue";

export default {
  components: {
    NextStepProject,
    InputFiles,
    InputMultipleFiles,
    selectResponsibleType,
    AverageNextStep,
  },
  props: {
    openModal: {
      type: Boolean,
      default: false
    },
    closeFunc: {
      type: Function,
      default: () => { }
    },
    idProject: {
      type: String,
      default: null
    },
    idLead: {
      type: String,
      default: null
    },
    idDiagnostic: {
      type: String,
      default: null
    },
  },
  data: () => ({
    uploadedFiles: [],
    buttonMessage: "Solicitar Contrato",
    proposalsToGetContract: [],
    contract: {
      contractFile: null,
      observations: null,
      proposals: [],
      uploadDocumentsPath: [],
    },
    selectProposalDialog: false,
    validForm: false,
    project: {},
    proposalList: [],
    is_loading: false,
    closingData: {
      name: null,
      document: null,
      address: null,
      cnpjCard: null,
      billingEmail: null,
      billingPhone: null,
      responsibleName: null,
      id_responsible_type: null,
      responsibleEmail: null,
      responsibleCPF: null,
      responsibleRG: null,
      responsibleId: null,
      condoMinutes: null,
    },
    useClientData: false,
    localLeadId: null,
    options: [
      { text: "Modelo Performance", value: "model_performance", disabled: false },
      { text: "Venda do Projeto", value: "payback_sell", disabled: false },
      { text: "Investimento", value: "investment", disabled: false },
      { text: "Pré-Fixado", value: "pre_fixed", disabled: false }
    ],
    additionalFiles: [],
    startLoading: false,
    initialContract: null,
    showAverageNextStep: false,
    nextStepVariable: "fechamento",
  }),

  computed: {
    rulesRequired() {
      return Rules.required();
    },
    ruleEmail() {
      return Rules.email();
    },
    ruleCPF() {
      return Rules.cpf();
    },
  },

  methods: {
    async handleUseClientDataChange(value) {
      if (value) {
        const [status, lead] = await LeadsService.getLeadById(this.localLeadId);
        if (status) {
          this.closingData.billingEmail = lead.email;
          this.closingData.billingPhone = lead.phone;
        }
      } else {
        this.closingData.billingEmail = null;
        this.closingData.billingPhone = null;
      }
    },
    async loadContractData() {
      if(this.project.id_contract){
        this.initialContract = await ContractsService.getContractById(this.project.id_contract);
        const contract = cloneDeep(this.initialContract)
        if (contract) {
          // Load selected proposals
          if (contract.proposals) {
            this.proposalsToGetContract = contract.proposals;
          }
  
          // Load observations
          if (contract.observations) {
            this.contract.observations = contract.observations;
          }
  
          // Load additional files
          if (contract.additionalFiles) {
            try {
              // Get list of files from the additionalFiles path
              const files = await ContractStorage.listFiles(`contracts/${contract.additionalFiles}`);
              this.additionalFiles = [];
              
              // Download each file
              for (const file of files) {
                try {
                  const downloadedFile = await ContractStorage.downloadImg(file.path);
                  if (downloadedFile) {
                    // Create a new File object with the original name
                    const fileWithName = new File([downloadedFile], file.name, {
                      type: downloadedFile.type
                    });
                    this.additionalFiles.push(fileWithName);
                  }
                } catch (error) {
                  console.error(`Error downloading file ${file.name}:`, error);
                }
              }
            } catch (error) {
              console.error("Error loading additional files:", error);
            }
          }
        }
      }
    },
    async loadLeadData() {
      const [status, lead] = await LeadsService.getLeadById(this.localLeadId);
      if (status) {
        this.closingData.name = lead.name;
        this.closingData.document = lead.document;
        this.closingData.address = lead.address;
        this.closingData.responsibleName = lead.responsible_name;
        this.closingData.responsibleRG = lead.responsible_rg;
        this.closingData.id_responsible_type = lead.id_responsible_type;
        this.closingData.responsibleEmail = lead.responsible_email;
        this.closingData.responsibleCPF = lead.responsible_document;

        // Carrega dados de cobrança se existirem
        if (lead.billing_email) {
          this.closingData.billingEmail = lead.billing_email;
        }
        if (lead.billing_phone) {
          this.closingData.billingPhone = lead.billing_phone;
        }

        if (lead.path_file_cnpj_card && lead.hasOwnProperty('path_file_cnpj_card')) {
          this.closingData.file_file_cnpj_card = await LeadsStorage.downloadImg(lead.path_file_cnpj_card)
        }
        if (lead.path_file_responsible_id && lead.hasOwnProperty('path_file_responsible_id')) {
          this.closingData.file_responsible_id = await LeadsStorage.downloadImg(lead.path_file_responsible_id)
        }


      }
    },
    async addStautsProject(id_project, status, statusAdm = null) {
      await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.CLOSING, status, UtilsProjects.STEPS.CLOSING)
      await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.CLOSING, statusAdm ? statusAdm : status, UtilsProjects.STEPS.CLOSING, false)
    },
    addInputFile() {
      const newFile = {
        name: null,
        file: null,
      }
      this.uploadedFiles.unshift(newFile);
    },
    addAdditionalFile() {
      const newFile = {
        name: null,
        file: null,
      }
      this.additionalFiles.unshift(newFile);
    },
    async checkIfExistsDocumentImagesToSave(file, id_doc) {
      return await ContractStorage.uploadFile(
        id_doc,
        file
      );
    },
    async nextStep() {
      this.startLoading = true;
      if (!this.$refs.closingForm.validate()) {
        showErrorSnackBar("Por favor, preencha todos os campos obrigatórios");
        this.startLoading = false;
        return;
      }

      this.proposalList = await this.getProposalList()
      if (!this.proposalList.length) {
        showErrorSnackBar("Nao existem propostas aprovadas! Verifique o passo 3!")
        this.startLoading = false;
        return
      }

      await this.updateLead();
      await this.waitForAverageNextStep();
      await this.saveContract();
      await this.updateProjectSteps();
      
      this.startLoading = false;
    },
    async waitForAverageNextStep() {
            return new Promise(resolve => {
              this.showAverageNextStep = true;
          
              const modal = this.$refs.averageModal;
          
              const handler = () => {
                modal.$off('closed', handler);
                resolve();
              };
          
              modal.$on('closed', handler);
            });
          },
    async updateProjectSteps() {
      await UtilsProjects.updateProjectSteps(this.idProject, UtilsProjects.STEPS.CONTRACTS, true);
      await this.addStautsProject(this.idProject, 506, 505);
      showSuccessSnackBar("Contrato solicitado com sucesso!");

    },
    async updateLead() {
      try {
        const leadData = {
          name: this.closingData.name,
          document: this.closingData.document,
          address: this.closingData.address,
          responsible_name: this.closingData.responsibleName,
          id_responsible_type: this.closingData.id_responsible_type,
          responsible_email: this.closingData.responsibleEmail,
          responsible_document: this.closingData.responsibleCPF,
          responsible_rg: this.closingData.responsibleRG,
          billing_email: this.closingData.billingEmail,
          billing_phone: this.closingData.billingPhone,
        };

        // Upload files if they exist
        if (this.closingData.cnpjCard) {
          leadData.path_file_cnpj_card = await LeadsStorage.uploadFile(
            this.localLeadId,
            this.closingData.cnpjCard
          );
        }

        if (this.closingData.responsibleId) {
          leadData.path_file_responsible_id = await LeadsStorage.uploadFile(
            this.localLeadId,
            this.closingData.responsibleId
          );
        }
        await LeadsService.updateLead(this.localLeadId, leadData);
        showSuccessSnackBar("Dados do lead atualizados com sucesso!");
      } catch (error) {
        console.error("Erro ao atualizar lead:", error);
        showErrorSnackBar("Erro ao atualizar dados do lead");
      }
    },
    async getProposalList() {
      const status = {
        approved: "Aprovado",
        revision: "Revisão",
        reproved: "Reprovado",
        outdated: "Desatualizado"
      }
      const mapProposalsTypes = {
          model_performance: "Performance",
          investment: "Investimento",
          pre_fixed: "Pré-Fixado",
          management: "Gestão",
      }
      if (this.idDiagnostic) {
        let proposalList = await DiagnosticProposalService.getApprovedProposalByDiagnosticId(this.idDiagnostic)
        const usedTypes = proposalList.map(proposal => proposal.typeProposal.type);

        return proposalList.map((proposal) => {
          const option = this.options.find((model) => model.value === proposal.typeProposal.type);
          return {
            ...proposal,
            name: `${option ? option.text : mapProposalsTypes[proposal.typeProposal.type]} / 
            ${Utils.formatDateDayJs(new Date(proposal.createdAt.seconds * 1000), "DD-MM-YYYY[,] HH:mm")} / 
            ${status[proposal.revision.status]}`
          };
        });
      }
      return [];
    },
    isValidFile(file) {
      if (!file) return false;
      
      // Verifica se é um objeto File ou Blob
      if (!(file instanceof File || file instanceof Blob)) {
        console.error('Arquivo inválido: não é um File ou Blob');
        return false;
      }

      // Verifica o tipo do arquivo
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(file.type)) {
        console.error('Tipo de arquivo não permitido:', file.type);
        return false;
      }

      // Verifica o tamanho do arquivo (máximo 10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB em bytes
      if (file.size > maxSize) {
        console.error('Arquivo muito grande:', file.size);
        return false;
      }

      return true;
    },
    async saveContract() {
      this.is_loading = true
      const cleaned = this.additionalFiles.filter(file => file instanceof File);
      this.contract.proposals = this.proposalsToGetContract;

      if (this.project.id_contract !== null) {
        const currentContract = this.initialContract
        if (currentContract && currentContract.additionalFiles) {
          try {
            // Get list of existing files
            const existingFiles = await ContractStorage.listFiles(`contracts/${currentContract.additionalFiles}`);
            
            // Delete all existing files
            for (const file of existingFiles) {
              await ContractStorage.deleteImg(file.path);
            }
          } catch (error) {
            console.error("Error deleting existing files:", error);
          }
          
          // Upload new files to the additionalFiles subfolder
        }
        for (const file of cleaned) {
          if (this.isValidFile(file)) {
            const result = await ContractStorage.uploadFile(
              `${this.project.id_contract}/additionalFiles`,
              file,
              false // Não adiciona timestamp para manter o nome original
            );
          } else {
            showErrorSnackBar(`Arquivo ${file.name} inválido. Verifique o tipo e tamanho.`);
          }
        }
        this.contract.additionalFiles = `${this.project.id_contract}/additionalFiles`;
        await ContractsService.updateContractById(this.project.id_contract, this.contract);
      } else {
        const contract_id = await ContractsService.createContract(this.contract);
        
        // Upload new files to the additionalFiles subfolder for new contract
        for (const file of cleaned) {
          if (this.isValidFile(file)) {
            const result = await ContractStorage.uploadFile(
              `${contract_id}/additionalFiles`,
              file,
              false // Não adiciona timestamp para manter o nome original
            );
          } else {
            showErrorSnackBar(`Arquivo ${file.name} inválido. Verifique o tipo e tamanho.`);
          }
        }
        
        this.contract.additionalFiles = `${contract_id}/additionalFiles`;
        await ContractsService.updateContractById(contract_id, this.contract);
        await ProjectsService.updateProject(this.idProject, { id_contract: contract_id });
      }

      await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.CLOSING, "Contrato Solicitado");
      this.close();
      this.is_loading = false;
    },
    close() {
      this.closeFunc('closing')
    },
  },

  async created() {
    this.startLoading = true;
    const [status, project] = await ProjectsService.getProjectById(this.idProject);
    if (status) {
      this.project = project;
      this.localLeadId = project.id_lead;
      await this.loadLeadData();
      await this.loadContractData();
      this.proposalList = await this.getProposalList();
    }
    this.startLoading = false;
  }
}
</script>

<style scoped>
.v-card-title {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.v-card-text {
  padding: 16px;
}

.v-text-field--outlined>>>fieldset {
  border-color: rgba(0, 0, 0, 0.12);
}

.v-text-field--outlined:focus-within>>>fieldset {
  border-color: var(--v-primary-base);
}

.loader-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 200px);
  width: 100%;
}
</style>